import { fetchApi } from '@/config/axiosSetting';
import {
  GetEducationDetailQueryParamsType,
  GetEducationDetailQueryResponseType,
} from './getEducationDetailQuery.type';

export const getEducationDetailFunction = (
  params: GetEducationDetailQueryParamsType,
): Promise<GetEducationDetailQueryResponseType> => {
  return fetchApi.get(`/education/${params.id}/detail/`);
};
